/* eslint-disable import/prefer-default-export */
/**
 * Downloads a pkpass file for wallet integration
 *
 * @method downloadPkpass
 * @param {string} purchaseToken - The purchase token
 * @param {string} ticketId - The ticket ID
 * @param {string} apiKey - The API key for authentication
 * @param {string} purchaseUrl - The purchase API URL
 * @param {string} platform - The platform ('ios' or 'android')
 * @return {Promise<void>}
 */
export async function downloadPkpass(purchaseToken, ticketId, apiKey, purchaseUrl, platform) {
  const response = await fetch(
    `${purchaseUrl}/v2/purchases/${purchaseToken}/tickets/${ticketId}/pkpass?platform=${platform}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token token=${apiKey}`,
        'Accept': 'application/vnd.apple.pkpass',
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.blob();
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.download = `ticket-${purchaseToken}-${ticketId}.pkpass`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
